import { graphql, useStaticQuery } from 'gatsby';

const useGlobalHeader = () => {
  const { contentfulWebsiteHeader } = useStaticQuery(graphql`
    query {
      contentfulWebsiteHeader(contentful_id: { eq: "5L7ztzsWR023xJHi8v5plY" }) {
        ...WebsiteHeader
      }
    }
  `);
  return contentfulWebsiteHeader;
};

export default useGlobalHeader;
